import { render, staticRenderFns } from "./ChatRecentTab.vue?vue&type=template&id=682a2157&"
import script from "./ChatRecentTab.vue?vue&type=script&lang=ts&"
export * from "./ChatRecentTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports